import { render, staticRenderFns } from "./Contact-card-by-type.vue?vue&type=template&id=ec54fb62&scoped=true&"
import script from "./Contact-card-by-type.vue?vue&type=script&lang=js&"
export * from "./Contact-card-by-type.vue?vue&type=script&lang=js&"
import style0 from "./Contact-card-by-type.vue?vue&type=style&index=0&id=ec54fb62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec54fb62",
  null
  
)

export default component.exports